<!-- your-dialog.component.html -->
<div mat-dialog-content class="dilog_main_div_wrapper">
    <div class="chart_header_main_div">
        <div class="chart_header_logo_div">
            <img src="../../../../assets/img/Foodbud_name_in_grey.svg" alt="" style="width: 40px;">
        </div>
        <div class="tooltip" *ngIf="data.allergens_msg">
            <span style="color: #336cfb; font-size: 12px; cursor: pointer;">Allergen Message</span>
            <span class="tooltiptext tooltipRankUp"><span>{{data.allergens_msg}}</span></span>
        </div>
        <div class="chart_header_info_div">
            You can find this template, including more information at <a href="https://www.food.gov.uk/aalergy-guidance"
                target="_blank">
                www.food.gov.uk/aalergy-guidance
            </a>
        </div>
    </div>

    <div class="chart_main_table_div">
        <table class="dataframe myfavourite_table">
            <thead>
                <tr style="text-align: right;">
                    <th class="dishes_const_text">Dishes</th>
                    <ng-container *ngFor="let item of allergensData">
                        <th>
                            <div>
                                {{item.allergens_name}}
                            </div>
                        </th>
                    </ng-container>
                </tr>
                <tr>
                    <td class="dishes_const_text">&nbsp;</td>
                    <ng-container *ngFor="let item of allergensData">
                        <td style="min-width: 50px;"><img [src]="item.image" alt="img"></td>
                    </ng-container>

                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let item of dishesData">
                    <tr>
                        <td style="max-width: 190px;min-width: 150px; text-align: left;" class="dish_name_td">
                            {{item.name}}</td>
                        <ng-container *ngFor="let allergens of allergensData">
                            <td *ngIf="allergensExist(item.allergens,allergens);else emptyTd">
                                <img src="../../../../assets/img/allegen_icons_check-mark.svg" alt="">
                                <span *ngIf="getOptionAvailabel(item.allergens,allergens)"
                                    style="margin-top: 5px;display: inline-block;font-size: 10px;">(O/A)</span>
                            </td>
                            <ng-template #emptyTd>
                                <td>&nbsp;</td>
                            </ng-template>

                        </ng-container>

                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
    <div class="note_msg_div">Note:- (O/A) indicates Option Available</div>
    <div class="reviewed_dtls_main_div">
        <div>
            <div class="reviewed_heading">Review Date:</div>
            <div class="reviewed_dtls">{{formatDate(reviewedBy[0].reviewed_date)}}</div>
        </div>
        <div>
            <div class="reviewed_heading">Reviewed By:</div>
            <div class="reviewed_dtls">{{reviewedBy[0].reviewed_by ? reviewedBy[0].reviewed_by : 'N/A'}}</div>
        </div>
    </div>
</div>

<style>
    .dilog_main_div_wrapper {
        display: flex;
        flex-direction: column;
        max-height: 80vh;
        max-width: 380px;
    }

    .chart_main_table_div {
        overflow-y: auto;
        overflow-x: auto;
        max-width: 380px;
    }

    .chart_main_table_div::-webkit-scrollbar {
        display: block !important;
    }

    /* Optional: Style the scrollbars to the default look */
    .chart_main_table_div::-webkit-scrollbar-track {
        box-shadow: inset 0 0 2px rgba(#000, .1);
    }

    .chart_main_table_div::-webkit-scrollbar {
        background: rgba(#fff, .2);
        position: absolute;
        width: 2px;
    }

    .chart_main_table_div::-webkit-scrollbar:hover {
        display: block;
    }

    .chart_main_table_div::-webkit-scrollbar-thumb {
        background-color: main-palette(100);
    }

    .chart_main_table_div::-webkit-scrollbar:horizontal {
        height: 10px;
    }

    .chart_main_table_div::-webkit-scrollbar-thumb:vertical {
        background-color: #1BACDB;
        border-radius: 10px;
    }

    .chart_main_table_div::-webkit-scrollbar:vertical {
        width: 5px;

    }

    .cdk-overlay-pane {
        max-width: 350px !important;
    }

    ::ng-deep .allergen_chart_table .mat-dialog-container {
        padding: 10px !important;
    }

    .chart_header_main_div {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    /* .chart_header_logo_div {
        width: 30%;
    } */

    .chart_header_info_div {
        width: 49%;
        font-size: 10px;
    }

    .rotate_div {
        transform: rotate(-90deg);
    }





    .dishes_const_text {
        font-size: 16px;
        font-weight: 500;
        text-align: left;
        vertical-align: bottom;
        padding-bottom: 10px;
        padding-left: 5px;
        position: sticky;
        left: 0;
        background: white;
        z-index: 3;
    }






    .myfavourite_table {
        font-size: 9pt;
        font-family: Arial;
        border-collapse: separate;
        border: 1px solid silver;
        border-spacing: 0px;
        text-align: center;
        vertical-align: middle;
        margin-bottom: 10px;
    }

    .myfavourite_table tr th,
    .myfavourite_table tr td {
        border: 1px solid silver;
    }

    .myfavourite_table thead {
        position: sticky;
        top: 0;
        background-color: white;
        z-index: 2;
    }

    .myfavourite_table tbody .dish_name_td {
        position: sticky;
        left: 0;
        background-color: white;
        z-index: 1;
    }


    .myfavourite_table th:not(:nth-child(1)) {
        vertical-align: bottom;
    }

    .myfavourite_table th:not(:nth-child(1)) div {
        writing-mode: vertical-rl;
        padding: 0;
        margin: 0;
        font-size: 8pt;
        transform: scale(-1);
        padding: 0.25em 1em;
        line-height: 0.5;
        vertical-align: top;
        text-align: left;
        vertical-align: middle;
        padding-top: 10px;
        padding-bottom: 25px;
        font-weight: 500;
        display: flex;
        width: 100%;
        align-items: center;
    }

    .myfavourite_table td {
        padding: 0.8em;
    }

    .note_msg_div {
        text-align: end;
        font-size: 12px;
    }

    .reviewed_dtls_main_div {
        display: grid;
        grid-template-columns: 1fr 1fr;
        margin-top: 10px;
    }

    .reviewed_heading {
        font-size: 12px;
        font-weight: 300;
    }

    .reviewed_dtls {
        font-weight: 500;
        font-size: 13px;
    }


    .dilog_main_div_wrapper .tooltip {
        position: relative;
        display: inline-block;
        opacity: 1 !important;
        z-index: 11 !important;
        cursor: pointer;
    }

    .dilog_main_div_wrapper .tooltip .tooltiptext {
        visibility: hidden;
        background-color: #F4FFF4;
        color: #4E4E4E;
        text-align: center;
        border-radius: 9px;
        padding: 10px;
        position: absolute;
        letter-spacing: 0.3px;
        font-family: 'Roboto';
        top: 29px;
        left: -3.4em;
        transition: opacity 0.3s;
        width: max-content;
        min-width: 150px;
        max-width: 250px;
        font-size: 14px;
        box-shadow: -3px 3px 6px rgba(98, 98, 98, 0.15);
    }

    .dilog_main_div_wrapper .tooltip:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
    }
</style>